import React from 'react';
import { RadioButton } from 'primereact/radiobutton';
import { Controller } from 'react-hook-form';

const BaseRadio = ({
    id,
    name,
    value,
    className,
    loadingClassName,
    childrenClassName,
    disabled = false,
    isLoading = false,
    textValue,
    children,
    control,
    clearErrors,
    onKeyDown,
    onChange,
    required,
    readOnly,
    errors
}) => {
    return (
        <div className={className}>
            {control && (
                <Controller
                    render={({ field }) => (
                        <>
                            <RadioButton
                                inputId={id ?? name}
                                name={name}
                                value={value}
                                checked={field.value === value}
                                disabled={disabled}
                                onChange={(e) => {
                                    field.onChange(e.value);
                                    if (clearErrors) clearErrors(name);
                                }}
                                onKeyDown={onKeyDown}
                                required={required}
                                readOnly={readOnly}
                            />
                            <div className={childrenClassName}>
                                {textValue && isLoading && <span className={loadingClassName}>{textValue}...</span>}
                                {textValue && !isLoading && textValue}
                                {!textValue && children}
                            </div>
                        </>
                    )}
                    control={control}
                    name={name}
                />
            )}

            {!control && (
                <>
                    <RadioButton
                        inputId={id ?? name}
                        name={name}
                        value={value}
                        checked={false}
                        disabled={disabled}
                        onChange={(e) => {
                            if (onChange) onChange(e);
                        }}
                        onKeyDown={onKeyDown}
                        required={required}
                        readOnly={readOnly}
                    />
                    <div className={childrenClassName}>
                        {textValue && isLoading && <span className={loadingClassName}>{textValue}...</span>}
                        {textValue && !isLoading && textValue}
                        {!textValue && children}
                    </div>
                </>
            )}

            {errors &&
                errors.map((error) => {
                    return (
                        <div key={error} className='mt-2.5 text-theme1-error'>
                            {error}
                        </div>
                    );
                })}
        </div>
    );
};

export default BaseRadio;
